"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = void 0;
const utils_1 = require("@aws-amplify/core/internals/utils");
const utils_2 = require("../../utils");
const client_1 = require("../../utils/client");
const userAgent_1 = require("../../utils/userAgent");
const utils_3 = require("../../../../utils");
const remove = async (amplify, input) => {
    const { key, options = {} } = input;
    const { s3Config, keyPrefix, bucket } = await (0, utils_2.resolveS3ConfigAndInput)(amplify, options);
    const finalKey = `${keyPrefix}${key}`;
    utils_3.logger.debug(`remove "${key}" from "${finalKey}".`);
    await (0, client_1.deleteObject)({
        ...s3Config,
        userAgentValue: (0, userAgent_1.getStorageUserAgentValue)(utils_1.StorageAction.Remove),
    }, {
        Bucket: bucket,
        Key: finalKey,
    });
    return {
        key,
    };
};
exports.remove = remove;
